import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import Text from "cms/components/Text";
import ShoutoutImage from "cms/images/shoutout-image-a.png";

import {
  Container,
  Content,
  Illustration,
  IllustrationContainer,
  Link,
  Message,
  Tagline,
} from "./ShoutoutBlock.styles";

export interface ShoutoutBlockProps extends Queries.SanityShoutoutBlock {}

const ShoutoutBlock: React.FC<ShoutoutBlockProps> = ({
  headline,
  tagline,
  buttonUrl,
}) => (
  <Container>
    <Content>
      <Message>
        <Text variant="H3" as="h3" color="#fff">
          {headline}
        </Text>
        <Tagline>{tagline}</Tagline>
        <Link href={buttonUrl ?? "https://app.uizard.io/sign-up/"}>
          <Button label="Sign up for free" variant="primary" />
        </Link>
      </Message>
      <IllustrationContainer>
        <Illustration
          src={ShoutoutImage}
          alt="Screenshot of mobile app screens and web pages designed in Uizard"
        />
      </IllustrationContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment ShoutoutBlock on SanityShoutoutBlock {
    _key
    _type
    headline
    tagline
    buttonUrl
  }
`;

export default ShoutoutBlock;
